/**
 * This file was auto-generated by scripts/generate-pagination-paths.ts
 * Do not make direct changes to the file.
 */

export const GET_LAST_ID_PATHS = [
  "/collections/{id}/prayers",
  "/intentions",
  "/journals",
  "/moodchecks",
  "/notifications",
  "/trusted/collections/{id}/prayers",
] as const;

export const GET_LAST_ID_PATHS_SET = new Set<string>(GET_LAST_ID_PATHS);
